class PriceListsAndPromotionsToEventTransformer {
  checkForNull(value) {
    return value && value != 0
  }

  transform (eventMaster, products, campaigns) {
    let event = {
      id: eventMaster.id,
      eventCode: eventMaster.eventCode,
      name: eventMaster.name,
      regionId: eventMaster.regionId,
      startDate: eventMaster.startDate,
      endDate: eventMaster.endDate,
      notes: eventMaster.notes,
      type: eventMaster.type,
      isConfirmed: eventMaster.active,
      isLocked: eventMaster.locked,
      discountedProducts: [],
      specialPromotions: [],
      deletedDiscountsAndPromotions: []
    }

    if (!products) {
      return event
    }

    for (let product of products) {
      event.discountedProducts.push({
        id: product.productId,
        customerGroupId: product.customerGroupId ? parseInt(product.customerGroupId) : 0,
        salesPrice: product.price,
        startDate: product.startDate,
        endDate: product.endDate,
        page: product.page,
        positionOnPage: product.positionOnPage,
        priceListProductId: product.priceListProductId,
        targetMargin: product.targetMargin,
        rewardsSubsidy: product.rewardsSubsidy,
        rewardMoneyEarnedPerItem: product.rewardMoneyEarnedPerItem,
        hasBeenEdited: false
      })
    }

    for (let promotion of campaigns) {
      let rewards = {
        redemptionLimit: promotion.rewards.redemptionLimit === null ? promotion.rewards.salesRedemptionLimit : promotion.rewards.redemptionLimit,
        salesRedemptionLimit: promotion.rewards.salesRedemptionLimit,
        maxItemsWithSpecialUnitPrice: promotion.rewards.maxItemsWithSpecialUnitPrice,
        //specialUnitPrice: (promotion.rewards.specialUnitPrice && promotion.rewards.specialUnitPrice !== 0) ? promotion.rewards.specialUnitPrice : null,
        specialUnitPrice: this.checkForNull(promotion.rewards.specialUnitPrice) ? parseFloat(promotion.rewards.specialUnitPrice) : null,

        rewardMoneyEarnedPerItem: promotion.rewards.rewardMoneyEarnedPerItem,
        rewardMoneyEarnedPerRedemption: promotion.rewards.rewardMoneyEarnedPerRedemption,
        awardedAmount: parseInt(promotion.rewards.awardedAmount),
        awardedProducts: promotion.rewards.awardedProducts,
      //  sumOff: promotion.rewards.sumOff ? parseFloat(promotion.rewards.sumOff) : null,
      //  percentageOff: promotion.rewards.percentageOff ? parseFloat(promotion.rewards.percentageOff) : null,
      //  sumOffMatchingItems: promotion.rewards.sumOffMatchingItems ? parseFloat(promotion.rewards.sumOffMatchingItems) : null,
      //  percentageOffMatchingItems: promotion.rewards.percentageOffMatchingItems ? parseFloat(promotion.rewards.percentageOffMatchingItems) : null
        sumOff: this.checkForNull(promotion.rewards.sumOff) ? parseFloat(promotion.rewards.sumOff) : null,
        percentageOff: this.checkForNull(promotion.rewards.percentageOff) ? parseFloat(promotion.rewards.percentageOff) : null,
        sumOffMatchingItems: this.checkForNull(promotion.rewards.sumOffMatchingItems) ? parseFloat(promotion.rewards.sumOffMatchingItems) : null,
        percentageOffMatchingItems: this.checkForNull(promotion.rewards.percentageOffMatchingItems)
          ? parseFloat(promotion.rewards.percentageOffMatchingItems) : null


      }

      if (promotion.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotion.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type === 'MULTIBUY_GET_SUM_OFF') {
        rewards.sumOff = rewards.sumOffMatchingItems ? parseFloat(rewards.sumOffMatchingItems) : rewards.sumOff
        rewards.percentageOff = rewards.percentageOffMatchingItems ? parseFloat(rewards.percentageOffMatchingItems) : rewards.percentageOff

        rewards.sumOffMatchingItems = rewards.sumOff
        rewards.percentageOffMatchingItems = rewards.percentageOff
      }

      event.specialPromotions.push({
        campaignId: promotion.campaignId,
        id: promotion.campaignId,
        eventId: promotion.eventId,
        name: promotion.name,
        startDate: promotion.startDate,
        endDate: promotion.endDate,
        customerGroupId: promotion.customerGroupId ? parseInt(promotion.customerGroupId) : 0,
        page: promotion.page,
        positionOnPage: promotion.positionOnPage,
        type: promotion.type,
        reasonId: promotion.reasonId,
        oncePerDay: promotion.oncePerDay,
        targetMargin: promotion.targetMargin,
        subsidyPercentageOfDiscount: promotion.subsidyPercentageOfDiscount,
        rewardsSubsidy: promotion.rewardsSubsidy,
        requirements: {
          purchaseTotalValue: parseFloat(promotion.requirements.purchaseTotalValue),
          purchasedAmount: parseInt(promotion.requirements.purchasedAmount),
          purchasedProducts: promotion.requirements.purchasedProducts
        },
        rewards: rewards,
        hasBeenEdited: false
      })
    }

    console.log('transform event')
    console.log(event)
    return event
  }
}
export default PriceListsAndPromotionsToEventTransformer



// WEBPACK FOOTER //
// ./src/transformers/PriceListsAndPromotionsToEventTransformer.js